export enum GenericRole {
  INPUT_VALUE = 'inputValue',
  INPUT_VALUE_OPTIONS = 'inputValueOptions',
}
